import React, { FC, useEffect, useState } from 'react'
import Button from '@material-ui/core/Button'
import { makeStyles } from '@material-ui/core'
import AccessLoader from '@/routes/Pages/ReservationDetail/access/AccessLoader'
import { format } from 'date-fns'
import { useTypedSelector } from '@/hooks/use-typed-selector'

const useStyles = makeStyles(() => ({
    component: {
       display: 'grid',
        paddingTop: '20px',
        paddingBottom: '20px',
        rowGap: '12px',
    },
    button: {
        maxWidth: '155px'
    }
}))

interface Props {
    readonly enableAccess: () => void;
    readonly isGeneratingKeys: boolean;
}

const NoAccessAvailable: FC<Props> = ({ enableAccess, isGeneratingKeys }) => {
    const classes = useStyles()
    const { scheduledKeysDate, isScheduledKeysLoading, isKeysDataLoading } = useTypedSelector(state => state.propertyKeys)
    const [formattedScheduleDate, setFormattedScheduleDate] = useState<string>('')

    useEffect(() => {
        if (scheduledKeysDate !== null) {
            const dateString = format(scheduledKeysDate, 'dd.MM.yyyy')

            setFormattedScheduleDate(dateString)
        }
    }, [scheduledKeysDate])

    const hasScheduledDate = isScheduledKeysLoading || formattedScheduleDate !== ''
    const isButtonDisabled = isGeneratingKeys || isKeysDataLoading || isScheduledKeysLoading || hasScheduledDate
    const isLoading = isGeneratingKeys || isKeysDataLoading || isScheduledKeysLoading

    return (
        <div className={classes.component}>
            { isLoading
                ? 'Loading...'
                : hasScheduledDate
                    ? <span>Door code generation has been scheduled for {formattedScheduleDate}</span>
                    : <span>No access available for this reservation</span>
            }

            <Button
                onClick={ enableAccess }
                className={classes.button}
                variant="contained"
                color="primary"
                disabled={isButtonDisabled}
            >
                Enable access
            </Button>

            { isGeneratingKeys && <AccessLoader /> }
        </div>
    )
}

export default NoAccessAvailable
